import React from "react";
import { useState } from "react";
import ReactS3Uploader from "react-s3-uploader";
import { useIntl, FormattedMessage } from "react-intl";
import { ProgressBar, Button } from "react-bootstrap";
import AlertModal from "../components/alert-modal";

// import Alert from "react-s-alert";

const UploadPresentation = ({
  token,
  presentation_id,
  event_id,
  speaker_id,
  onPptStatusChange,
  setProgress,
  progress,
  onFileName,
}) => {
   console.log(
    "Upload PDF",
    token,
    presentation_id,
    event_id,
    speaker_id
  );
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [pptmessage, setPptMessage] = useState("");
  const [progressCount, setProgressCount] = useState(0);
  const handleAlertModal = () => {
   // setShowAlertModal(!showAlertModal);
  };
  const intl = useIntl();
  const [fileName, setFileName] = useState("");
  return (
    <React.Fragment>
      <ReactS3Uploader
        placeholder="Presentation"
        className="file-input"
        signingUrl="/api/s3"
        signingUrlMethod="GET"
        accept=".ppt,.pptx,.pdf"
        preprocess={(file, next) => {
          next(file);
        }}
        onProgress={(p) => {
          setProgressCount(p);
          setAlertType("Progress");
          setPptMessage(intl.formatMessage({ id: 'uploading.file.message' }));
          setShowAlertModal(true);
        }}
        onError={() => {
           console.log("Upload PDF : Failed")
          setProgress(0);
          setProgressCount(0);
          setShowError(true);
          setTimeout(() => {
            setProgress(0);
            setProgressCount(0);
            setShowError(false);
          }, 3000);
        }}
        onFinish={(url) => {
          setProgress(0);
          setProgressCount(0);
           console.log("Upload PDF : Success",url.publicUrl)
          onPptStatusChange(url.publicUrl);
          setShowSuccess(true);
          setTimeout(() => {
            setProgress(0);
            setProgressCount(0);
            setShowSuccess(false);
          }, 3000);
        }}
        signingUrlHeaders={{
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        }}
        // pass complete object
        signingUrlQueryParams={{
          presentation_id: presentation_id,
          event_id: event_id,
          speaker_id: speaker_id,
        }}
        uploadRequestHeaders={{
          "x-amz-acl": "public-read",
        }}
        contentDisposition="auto"
        server={process.env.REACT_APP_API_ENDPOINT}
        scrubFilename={(filename) => {
          setFileName(filename);
          onFileName(filename);
          return filename;
        }}
      />

      <AlertModal
        show={showAlertModal}
        handleClose={handleAlertModal}
        type={alertType}
        progress={progressCount}
        message={pptmessage}
      />
    </React.Fragment>
  );
};

export default UploadPresentation;
